module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"btn":"Choose File"}}')
  delete Component.options._Ctor
}
